import { fetchResource } from 'helpers/fetch';
import { API_CONSTANTS } from 'constants/api';
import { getCounties, getCoverageCodes, getInsurers } from 'state/actions';

export const SUMMARY_ACTIONS = {
  SUMMARY_RETRIEVED: 'SUMMARY_RETRIEVED',
  SUMMARY_LOADING_SET: 'SUMMARY_LOADING_SET',
  SUMMARY_MAX_ATTEMPTS_REACHED: 'SUMMARY_MAX_ATTEMPTS_REACHED',
};

export const getSummaryData = async () => {
  const summary = await fetchResource(API_CONSTANTS.REPORT_SUMMARY);
  return summary;
};

export const setSummaryLoading = (loading) => ({
  type: SUMMARY_ACTIONS.SUMMARY_LOADING_SET,
  data: { loading },
});

export const setSummaryMaxAttemptsReached = (maxAttemptsReached) => ({
  type: SUMMARY_ACTIONS.SUMMARY_MAX_ATTEMPTS_REACHED,
  data: { maxAttemptsReached },
});

export const getSummary = () => async (dispatch, getState) => {
  const {
    summary: {
      quarterlyPremiumTrend,
      countyWiseData,
      allLines,
      commercialLines,
      fastFacts,
      quarter,
      year,
      requestAttempts = 1,
    } = {},
  } = getState();

  if (
    (!quarterlyPremiumTrend ||
      !countyWiseData ||
      !allLines ||
      !commercialLines ||
      !fastFacts ||
      !quarter ||
      !year) &&
    requestAttempts < 3
  ) {
    dispatch(setSummaryLoading(true));
    const {
      quarterlyPremiumTrend = [],
      countyWiseData = [],
      allLines = [],
      commercialLines = [],
      fastFacts = {},
      quarter = 0,
      year = 0,
    } = await getSummaryData();
    dispatch({
      type: SUMMARY_ACTIONS.SUMMARY_RETRIEVED,
      data: {
        quarterlyPremiumTrend,
        countyWiseData,
        allLines,
        commercialLines,
        fastFacts,
        quarter,
        year,
        requestAttempts: quarterlyPremiumTrend.length ? 1 : requestAttempts + 1,
      },
    });

    dispatch(setSummaryLoading(false));

    // Chaining the lookups together as a pre-load, assuming the user has hit the main page
    dispatch(getCounties());
    dispatch(getCoverageCodes());
    dispatch(getInsurers());
  }

  if (requestAttempts >= 3) {
    dispatch(setSummaryMaxAttemptsReached(true));
  }
};
